import React from 'react';
import AgeSelect from '../component/ageSelect';
import CheckBox from '../component/checkBoxTelemer';

let multiselectQuery1CB = [
  "Insomnia","Scleroderma","Hepatitis","Polio","Amputation","Physical Disability","Diabetes","Hpercholesterolemia","Thalessemia","Hypertension"
];
let multiselectQuery2CB = ["Dengue","Malaria","Typhoid","Chikungunya","Swine Flu","Pneumonia","Accident","Operation","Fracture"];
let multiselectQuery3CB = ["Cigarette","Beedi","Pan","Gutka","Alcohol"];
let multiselectQuery4CB = ["Cancer","Tumor","Cyst","Growth of any kind","Blood related disorder","Heart related problem","Raised blood pressure","Cholestrol problems","Diabetes","Hepatitis","HIV/AIDS","VDRL","Sexually transmitted diseases"];
let multiselectQuery5CB = ["Asthma","Bronchitis","Tuberculosis","Coughing with blood","Lung infection","Breathing difficulty","Vision","Hearing","Eye","Nose","Throat problem","Thyroid problem"];
let multiselectQuery6CB = ["Kidney","Ureter","Bladder","Prostate","Reproductive organs","blood, protien or sugar in the urine"];
let multiselectQuery7CB = ["Stomach","Stomach Ulcer","Gall stones","Jaundice","Hepatitis","Digestive problems"];
let multiselectQuery8CB = ["I confirm that all the information provided is correct to the best of my knowledge."];
let multiselectQuery9CB = ["Adverse menstrual history","Disease of uterus","Breast","Cervix","Ovaries","PAP smear","Mamogram","USG Pelvis"];
let multiselectQuery10CB = ["Breast","Uterus","Cervix"];
let multiselectQuery11CB = ["History of miscariage or abortion","Pregnancy related complications","Gestational diabetes"];
let result = {};
const populateResults = function(queryName,elementList){ 
  result[queryName]=[];
  for(var key in elementList){
    result[queryName].push({message:elementList[key].tag,value:elementList[key].active});
  }
}

let questions = [
  {
    id: '1',
    message: 'Enter your name',
    trigger:'nameQuery'
  },
  {
    id: 'nameQuery',
    user: true,
    waitAction: true,
    trigger:'2'
  },
  {
    id: '2',
    message: 'Hi {previousValue}, Enter your email address',
    trigger:'emailQuery'
  },
  {
    id: 'emailQuery',
    user: true,
    waitAction: true, 
    trigger:'3'
  },
  {
    id: '3',
    message: 'Enter you height',
    trigger:'heightQuery'
  },
  {
    id: 'heightQuery',
    user: true,
    waitAction: true,
    trigger:'4'
  },
  {
    id: '4',
    message: 'Enter your weight',
    trigger:'weightQuery'
  },
  {
    id: 'weightQuery',
    user: true,
    waitAction: true,
    trigger:'5'
  },
  {
    id: '5',
    message: 'What is your age?',
    trigger: 'ageQuery',
  },
  {
    id: 'ageQuery',
    component: <AgeSelect />,
    waitAction: true,
    trigger: '7',
  },
  {
    id: '7',
    message: 'Are you currently under treatment for any of these?',
    trigger: 'multiselectQuery1',
  },
  {
    id: 'multiselectQuery1',
    component: <CheckBox checkBoxElements = {multiselectQuery1CB} queryName = "multiselectQuery1" populateResults={populateResults}/>,
    waitAction: true,
    trigger:'8'
  },
  {
    id: '8',
    message: 'Have you undergone any of blood test, urine test, x-ray, ECG, CTMT, MRI scan, blood transfusion recently?',
    trigger: 'singleselectQuery1',
  },
  {
    id: 'singleselectQuery1',
    options: [
        { value: 'Yes', label: 'Yes', trigger: '9' },
        { value: 'No', label: 'No', trigger: '9' }
    ],
  },
  {
    id: '9',
    message: 'Have you been hospitalised or remain absent from work for more than 7 days due to illness, sickness, disease, disorder, injury, accident?',
    trigger: 'singleselectQuery2',
  },
  {
    id: 'singleselectQuery2',
    options: [
      { value: 'Yes', label: 'Yes', trigger: '10' },
      { value: 'No', label: 'No', trigger: '10' },
    ],
  },
  {
    id: '10',
    message: 'Are you suffering from any of these?',
    trigger: 'multiselectQuery2',
  },
  {
    id: 'multiselectQuery2',
    component: <CheckBox checkBoxElements = {multiselectQuery2CB} queryName = "multiselectQuery2" populateResults={populateResults}/>,
    waitAction: true,
    trigger: '11'
  },
  {
    id: '11',
    message: 'Are you experiencing weight loss/gain, joint or muscle pain/stiffness/swelling, weakness or any other physical disability?',
    trigger: 'singleselectQuery3',
  },
  {
    id: 'singleselectQuery3',
    options: [
        { value: 'yes', label: 'yes', trigger: '12' },
        { value: 'no', label: 'no', trigger: '12' },
    ],
  },{
    id: '12',
    message: 'Are you experiencing stress, depression, anxiety, blackouts, fits, convulsions, epilepsy, neurological symptoms?',
    trigger: 'singleselectQuery4',
  },
  {
    id: 'singleselectQuery4',
    options: [
      { value: 'Yes', label: 'Yes', trigger: '13' },
      { value: 'No', label: 'No', trigger: '13' },
    ],
  },
  {
    id: '13',
    message: 'Do you have a habit of consuming any of these?',
    trigger: 'multiselectQuery3',
  },
  {
    id: 'multiselectQuery3',
    component: <CheckBox checkBoxElements = {multiselectQuery3CB} queryName = "multiselectQuery3" populateResults={populateResults}/>,
    waitAction: true,
    trigger: '14'
  },
  {
    id: '14',
    message: 'Either you or your family member have cancer, tumor, cyst, growth of any kind, blood related disorder, heart related problem, raised blood pressure, cholestrol problem, diabetes, hepatits, HIV/AIDS, VDRL or any other sexually transmitted desease?',
    trigger: 'multiselectQuery4',
  },
  {
    id: 'multiselectQuery4',
    component: <CheckBox checkBoxElements = {multiselectQuery4CB} queryName = "multiselectQuery4" populateResults={populateResults}/>,
    waitAction: true,
    trigger: '15'
  },
  {
    id: '15',
    message: ' Are you experiencing any chest pain, fainting, palpitation, breathlessness to relate with any heart desease?',
    trigger: 'singleselectQuery5',
  },
  {
    id: 'singleselectQuery5',
    options: [
      { value: 'Yes', label: 'Yes', trigger: '16' },
      { value: 'No', label: 'No', trigger: '16' },
    ],
  },
  {
    id: '16',
    message: 'Are you experiencing any of these?',
    trigger: 'multiselectQuery5',
  },
  {
    id: 'multiselectQuery5',
    component: <CheckBox checkBoxElements = {multiselectQuery5CB} queryName = "multiselectQuery5" populateResults={populateResults}/>,
    waitAction: true,
    trigger: '17'
  },
  {
    id: '17',
    message: 'Are you experiencing problems related to any of these?',
    trigger: 'multiselectQuery6',
  },
  {
    id: 'multiselectQuery6',
    component: <CheckBox checkBoxElements = {multiselectQuery6CB} queryName = "multiselectQuery6" populateResults={populateResults}/>,
    waitAction: true,
    trigger: '18'
  },
  {
    id: '18',
    message: 'Are you experiencing problems related to any of these?',
    trigger: 'multiselectQuery7',
  },
  {
    id: 'multiselectQuery7',
    component: <CheckBox checkBoxElements = {multiselectQuery7CB} queryName = "multiselectQuery7" populateResults={populateResults}/>,
    waitAction: true,
    trigger: '6'
  },
  {
    id: '6',
    message: 'Please select your gender',
    trigger: 'genderQuery',
  },
  {
    id: 'genderQuery',
    options: [
      { value: 'male', label: 'Male', trigger: 'multiselectQuery8' },
      { value: 'female', label: 'Female', trigger: '19' },
    ],
  },
  {
    id: '19',
    message: 'Do you have problems related to any of these?',
    trigger: 'multiselectQuery9',
  },
  {
    id: 'multiselectQuery9',
    component: <CheckBox checkBoxElements = {multiselectQuery9CB} queryName = "multiselectQuery9" populateResults={populateResults}/>,
    waitAction: true,
    trigger: '20'
  },
  {
    id: '20',
    message: 'Have you visisted a medical practioner of any of these?',
    trigger: 'multiselectQuery10',
  },
  {
    id: 'multiselectQuery10',
    component: <CheckBox checkBoxElements = {multiselectQuery10CB} queryName = "multiselectQuery10" populateResults={populateResults}/>,
    waitAction: true,
    trigger: '21'
  },
  {
    id: '21',
    message: 'Please select if any applicable.',
    trigger: 'multiselectQuery11',
  },
  {
    id: 'multiselectQuery11',
    component: <CheckBox checkBoxElements = {multiselectQuery11CB} queryName = "multiselectQuery11" populateResults={populateResults}/>,
    waitAction: true,
    trigger: 'multiselectQuery8'
  },
  {
    id: 'multiselectQuery8',
    component: <CheckBox checkBoxElements = {multiselectQuery8CB} queryName = "multiselectQuery8" end = {true} result={result}/>,
    waitAction: true,
    end:true
  }
]
export default questions